/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import "../css/application.css";
import 'floating-vue/dist/style.css'
import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import TurbolinksAdapter from "vue-turbolinks";
import Vue from "vue";
import DateRangePicker from "../components/date-range-picker.vue";
import CustomDateRangePicker from "../components/custom-date-range-picker.vue";
import CustomDatePicker from "../components/custom-date-picker.vue";
import CustomDatePickerBlank from "../components/custom-date-picker-blank.vue";
import Pagination from "../components/financial/cashflow/pagination.vue";
import Cashflow from "../components/financial/cashflow/cashflow.vue";
import FinancialOverview from "../components/financial/financial-overview.vue";
import FinancialCharts from "../components/financial/financial-charts.vue";
import FinancialHealth from "../components/financial/financial-health.vue";
import Patients from "../components/patients.vue";
import PhotoCropUpload from "../components/photo-crop-upload.vue";
import { Cropper, CircleStencil } from "vue-advanced-cropper";
import Campaigns from "../components/campaigns.vue";
import CustomCampaign from "../components/custom-campaign.vue";
import { ContentLoader } from "vue-content-loader"
import FloatingVue from 'floating-vue'
import '../components/occupancy-level/index'
import runTooltips from "./static/tooltip.js";
import UploadFilenameInput from "../components/upload-filename-input.vue";
import UploadEditNotesInline from "../components/upload-edit-notes-inline.vue";
import Boletos from "../components/boletos.vue";
import InsightsPage from "../components/insights/insights-page.vue";
import EventsPrint from "../components/events-print.vue";
import PatientsWaitingList from "../components/patients-waiting-list/index.vue"
import EventsTag from "../components/events-tag.vue"
import LineChart from "../components/charts/line-chart.vue"
import Chat from "../twenty_twenty_three/components/chat/chat.vue"
import "trix"
import countdown from "../helpers/countdown.js";

const application = Application.start();
// in case using stimulus inside vue will have problems stimulus fire twice.
// change placeholder in input link for trix editor
Trix.config.lang.urlPlaceholder = "Cole aqui a url...";
Trix.config.lang.link = "Vincular";
const context = require.context("controllers", true, /.js$/);
application.load(definitionsFromContext(context));
Vue.use(TurbolinksAdapter);

FloatingVue.options.defaultTemplate =
  '<div class="financial-tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>';
FloatingVue.options.themes.tooltip.html = true

Vue.use(FloatingVue, {
  html: true,
  themes: {
    'financial-tooltip': {
      $extend: 'tooltip'
    },
  },
})

Vue.component("DateRangePicker", DateRangePicker);
Vue.component("CustomDateRangePicker", CustomDateRangePicker);
Vue.component("CustomDatePickerBlank", CustomDatePickerBlank);
Vue.component("CustomDatePicker", CustomDatePicker);
Vue.component("Pagination", Pagination);
Vue.component("Cashflow", Cashflow);
Vue.component("FinancialOverview", FinancialOverview);
Vue.component("FinancialCharts", FinancialCharts);
Vue.component("FinancialHealth", FinancialHealth);
Vue.component("Patients", Patients);
Vue.component("Cropper", Cropper);
Vue.component("CircleStencil", CircleStencil);
Vue.component("PhotoCropUpload", PhotoCropUpload);
Vue.component("Campaigns", Campaigns);
Vue.component("CustomCampaign", CustomCampaign);
Vue.component("ContentLoader", ContentLoader);
Vue.component("UploadFilenameInput", UploadFilenameInput);
Vue.component("UploadEditNotesInline", UploadEditNotesInline);
Vue.component("Boletos", Boletos);
Vue.component("InsightsPage", InsightsPage);
Vue.component("EventsPrint", EventsPrint);
Vue.component("PatientsWaitingList", PatientsWaitingList)
Vue.component("EventsTag", EventsTag)
Vue.component("LineChart", LineChart)
Vue.component("Chat", Chat)

function renderVue() {
  document.querySelectorAll("[data-behavior='vue']").forEach(element => {
    if (element.__vue__) {
      return
    }
    const app = new Vue({
      el: element
    });
  });
}

document.addEventListener("render-vue-roots", () => {
  renderVue();
});

document.addEventListener("turbolinks:load", () => {
  runTooltips();
  renderVue();
  countdown();
});


/* Disabling file uploads with the Trix editor */
document.addEventListener("trix-file-accept", event => {
  event.preventDefault()
})
